module.exports = __webpack_public_path__ + "img/yuu_app_logo.f3641e5.png";